var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCompareIcon = function SvgCompareIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 7,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF8587",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m.75.75 1.648 1.442a.5.5 0 0 0 .683-.023L4.5.75M.75 4l1.648 1.442a.5.5 0 0 0 .683-.023L4.5 4"
  })));
};
export default SvgCompareIcon;